module.exports = __webpack_public_path__ + "img/1.e10ef7d4.jpg";